<template>
  <v-simple-table style="border: 1px solid #e0e0e0;" class="rounded-0">
    <template v-slot:default>
      <tbody>
        <tr v-for="(item, index) in filteredDesserts" :key="index">
          <td class="font-weight-regular text-body-2" width="50%">{{ Object.keys(item)[0] }}</td>
          <td class="font-weight-bold black--text text-body-1"
            :class="($vuetify.breakpoint.smAndDown) ? 'text-end' : 'text-start'">
            {{ Object.values(item)[0] }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['desserts'],
  computed: {
    filteredDesserts() {
      return this.desserts.filter(item => {
        const value = Object.values(item)[0];
        return value !== "" && value !== null;
      }).map(item => {
        const key = Object.keys(item)[0];
        let value = Object.values(item)[0];
        if (key.includes('FECHA') && value) {
          value = this.formatDate(value);
        }
        return { [key]: value };
      });
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    }
  }
}
</script>